const questions = [
  {
    question: "솔랭에서 실력도 좋고\n 호흡이 잘 맞는 유저를 만났습니다.",
    answer: ["다음판에도 만나게 해주세요 🙏", "같이 듀오하자고 해볼까?"],
  },
  {
    question: "친구가 모르는 친구를 초대해\n 같이 게임을 하자고 합니다.",
    answer: ["... 🤐", "하이요! 저는 탑 갈게요~!"],
  },
  {
    question: "나는 평소에",
    answer: [
      "게임시작 - 개인/2인\n랭크 게임 - 대전찾기",
      "친구야 한판 하실? ㄱㄱ?",
    ],
  },
  {
    question: "게임이 상대쪽으로\n 많이 기울었습니다.",
    answer: [
      "후반 조합은 우리가 더 좋아!\n 조금만 더 집중해보자",
      "15gg ㅅㄱ! 오픈이요~",
    ],
  },
  {
    question: "새로운 챔피언을 연습하기 전\n 내가 보는 영상은",
    answer: [
      "프로 선수들이 활약하는\n 하이라이트 영상",
      "스킬부터 차근차근 알려주는\n공략 영상",
    ],
  },
  {
    question: "롤 대회를 보던 중\n 숨겨졌던 꿀챔을 찾은 나는",
    answer: ["한 번 해볼까?", "그래도 하던 거 할래!"],
  },
  {
    question: "아군이 미니언을\n 양보해달라고 합니다.",
    answer: ["꺼억 🐷\n 몽땅 먹고 내가 캐리할래", "너가 먹고 캐리해줘"],
  },
  {
    question: "팀원이 ㅈㄱㅊㅇ를 외치고 던질 때\n나는",
    answer: ["너가 못해서 죽은 건\n 왜 말 안함?", "/all ㅈㄱㅊㅇ!!!"],
  },
  {
    question: "무수히 찍히는 바론핑 앞에서\n나는",
    answer: [
      "바론을 왜 감?\n 난 미드 포탑 밀 거야",
      "이거 맞나?\n 한번 믿어봐도 되겠지?",
    ],
  },
  {
    question: "새로 업데이트 된 챔피언이\n마음에 드는 나는",
    answer: ["공략부터 알아볼까?", "일단 시작!\n 하다보면 느낌 오겠지!"],
  },
  {
    question: "픽 창에서 아군이 캐리할 수 있다고\n 따라와 달라고 합니다.",
    answer: [
      "아군을 어떻게 믿어!\n 난 나만 믿는다",
      "불안하긴 한데\n 한번 믿어볼까?",
    ],
  },
  {
    question: "로딩 화면에서\n나는",
    answer: [
      "게임을 어떻게 풀어나갈지\n 계획을 짠다",
      "밀린 카톡 답장하고\n 유튜브도 잠깐 봐야지!",
    ],
  },
];

export default questions;
